"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTopAreaData = void 0;
var _getTopAreaNavigation = require("./getTopAreaNavigation");
// istanbul ignore file -- api

const getTopAreaData = async ({
  language,
  staticApiUrl,
  tenant
}) => {
  // Use Promise.allSettled when more data fetching is added here
  const topAreaNavigation = await (0, _getTopAreaNavigation.getTopAreaNavigation)({
    language,
    staticApiUrl,
    tenant
  });
  return {
    topAreaNavigation
  };
};
exports.getTopAreaData = getTopAreaData;